import useJwt from '@/auth/jwt/useJwt'

/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
// eslint-disable-next-line arrow-body-style
export const isUserLoggedIn = () => {
  return localStorage.getItem('userData') && localStorage.getItem(useJwt.jwtConfig.storageTokenKeyName)
}

export const getUserData = () => JSON.parse(localStorage.getItem('userData'))

/** Até este tamanho (inclusive) o nome permanece completo; acima disso vira "Nome S." se houver sobrenome */
const COMPACT_USER_NAME_MAX_FULL_LENGTH = 15

/**
 * Abrevia nome exibido quando o texto completo é longo: primeiro nome + inicial do último sobrenome.
 * @param {string} name fullName ou username
 * @returns {string}
 */
export const formatUserDisplayNameCompact = name => {
  if (!name || typeof name !== 'string') return ''
  const trimmed = name.trim()
  if (trimmed.length <= COMPACT_USER_NAME_MAX_FULL_LENGTH) return trimmed
  const parts = trimmed.split(/\s+/).filter(Boolean)
  if (parts.length < 2) return trimmed
  const first = parts[0]
  const last = parts[parts.length - 1]
  const initial = last.charAt(0)
  if (!initial) return first
  return `${first} ${initial.toLocaleUpperCase('pt-BR')}.`
}

/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
  if (userRole === 'admin') return '/'
  if (userRole === 'client') return '/'
  return { name: 'auth-login' }
}
